'use client';

import { Button, ButtonProps } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { HyperLink } from './HyperLink';
import { Grid } from '@/primitives';
import { green } from '@/lib/colours';

export function StatusCell({
  label,
  ...rest
}: { label: string } & ButtonProps) {
  return (
    <Button color="success" disableRipple {...rest}>
      {label}
    </Button>
  );
}

type TProps = {
  name: string;
  path?: string;
  active?: boolean;
};
function NameCell({ name, path, active }: TProps) {
  return (
    <Grid
      container
      sx={{
        justifyContent: 'space-between',
      }}
    >
      <Grid>
        <HyperLink label={!!name ? name : '--'} pathname={path ?? ''} />
      </Grid>
      <Grid>
        {active && (
          <StatusCell
            label="active"
            sx={{
              backgroundColor: alpha(green[600], 0.04),
              right: 'auto',
            }}
          />
        )}
      </Grid>
    </Grid>
  );
}

export default NameCell;
